var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('CrudCardTable',{attrs:{"items":_vm.establishments,"headers":_vm.headers,"title":"Establishments","button-to":{name: 'App-Establishments-New'}},scopedSlots:_vm._u([{key:"item.name",fn:function(ref){
var item = ref.item;
return [_c('router-link',{attrs:{"to":{ name: 'App-Establishments-id', params: { id: item.id } }}},[_vm._v(" "+_vm._s(item.name)+" ")])]}},{key:"item.tables",fn:function(ref){
var item = ref.item;
return [_vm._v(" "+_vm._s(item.tables.length)+" ")]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }